'use client';

import { renderAppIcon } from '@/components/icons/app-icon-registry';
import { cn } from '@/lib/ui/utils';

export function WorkspaceAssetsTrigger({
  label,
  open,
  onClick,
  placement,
  disabled = false,
}: {
  label: string;
  open: boolean;
  onClick: () => void;
  placement: 'upload-corner' | 'frame-corner' | 'label';
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className={cn(
        'cms-block-workspace-workspace-1-workspace-form-controls__neutralIconButton',
        'cms-block-workspace-workspace-1-workspace-form-controls__assetsTrigger',
        placement === 'upload-corner'
          ? 'cms-block-workspace-workspace-1-workspace-form-controls__assetsTriggerUploadCorner'
          : placement === 'frame-corner'
            ? 'cms-block-workspace-workspace-1-workspace-form-controls__assetsTriggerFrameCorner'
            : 'cms-block-workspace-workspace-1-workspace-form-controls__assetsTriggerLabel'
      )}
      aria-label={label}
      aria-haspopup="dialog"
      aria-expanded={open}
      title={label}
      disabled={disabled}
      onClick={onClick}
    >
      {renderAppIcon({
        name: 'history',
        className:
          'cms-block-workspace-workspace-1-workspace-form-controls__assetsTriggerIcon',
      })}
    </button>
  );
}
